import styled from 'styled-components';

export const Container = styled.div`
  @import '~antd/dist/antd.css';
`;
